import { useSelector } from 'react-redux';
import { hostTypeSelector, mobileSideSelector } from '../../../selectors';
import { EHostType } from '../../../types/hostType';
import { EMobileLayoutActiveSide } from '../../../types/mobileSide';
import { useApplicationContext } from '../../../utils/applicationContext';
import { EDeviceType } from '../../../types/deviceType';

const MESSAGE_INPUT_HEIGHT = 60;
const BOTTOM_NAVIGATION_MENU_HEIGHT = 60;
const BOTTOM_OFFSET = 8;

export const useAlertOffset = () => {
  const {
    custom: { realDevice },
  } = useApplicationContext();
  const isDesktop = realDevice === EDeviceType.Desktop;

  const hostType = useSelector(hostTypeSelector);
  const isIframe = hostType === EHostType.Frame;

  const mobileSide = useSelector(mobileSideSelector);
  const isChatSide = mobileSide !== EMobileLayoutActiveSide.Left;

  if (isDesktop || isIframe || isChatSide) {
    return MESSAGE_INPUT_HEIGHT + BOTTOM_OFFSET;
  }

  return BOTTOM_NAVIGATION_MENU_HEIGHT + BOTTOM_OFFSET;
};
